"use client"

// src/forward-ref.tsx
import * as React from "react";
function motionForwardRef(render) {
  return React.forwardRef(
    render
  );
}

export {
  motionForwardRef
};
//# sourceMappingURL=chunk-RXCU3ZFK.mjs.map